<template>
    <div v-if="row[index]">
        <SampleValueColumn swiper :key="row.id" :sample="row.sampleValue" :scopeName="row.scopeName" :carrierName="row.keycode"
            :typeId="row.typeId" :carrierId="row.id" :carrierInfo="carrierInfo"></SampleValueColumn>
    </div>
</template>

<script>
import SampleValueColumn from '@/components/SampleValueColumn/SampleValueColumn'
import { getCarrierInfoBrief } from '@/utils/simplify/carrierInfoBrief'
export default {
  props: ['row', 'index'],
  components: {
    SampleValueColumn
  },
  data () {
    return {
      carrierInfo: null
    }
  },
  mounted () {
    this.carrierInfo = getCarrierInfoBrief(this.row)
  }
}
</script>
